<template>
  <div class="offers-page">
    <div class="hero-card">
      <div>
        <h1>Cmimet</h1>
        <p>Rregullo cmimet ne mase me hapa te thjeshte: zgjidh ku aplikohet, parashiko dhe sinkronizo ne F5.</p>
      </div>
      <div class="hero-badge">Batch + F5</div>
    </div>

    <CmimetTab />

    <ConfirmActionModal
      :open="confirmModal.open"
      :title="confirmModal.title"
      :message="confirmModal.message"
      :warning="confirmModal.warning"
      :details="confirmModal.details"
      :confirm-word="confirmModal.confirmWord"
      :confirm-label="confirmModal.confirmLabel"
      :danger="confirmModal.danger"
      :loading="confirmModal.loading"
      :allow-schedule="confirmModal.allowSchedule"
      :schedule-item-count="confirmModal.scheduleItemCount"
      :schedule-item-cap="priceScheduleItemCap"
      @confirm="onConfirmModalConfirm"
      @cancel="closeConfirmModal"
    />
    <ImportErrorModal
      :open="importErrorModal.open"
      :title="importErrorModal.title"
      :message="importErrorModal.message"
      :errors="importErrorModal.errors"
      :payload="importErrorModal.payload"
      @close="closeImportErrorModal"
      @download="downloadImportErrorJson"
    />
  </div>
</template>

<script>
import pricingOffersMixin from "./shared/pricingOffersMixin.js";
import ConfirmActionModal from "./shared/ConfirmActionModal.vue";
import ImportErrorModal from "./shared/ImportErrorModal.vue";
import CmimetTab from "./cmimet/CmimetTab.vue";
import "./shared/pageStyles.css";

export default {
  name: "CmimetPage",
  pricingScreen: "cmimet",
  components: { ConfirmActionModal, ImportErrorModal, CmimetTab },
  mixins: [pricingOffersMixin],
  provide() {
    return { po: this };
  },
};
</script>
